import { Canvas } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Canvas';
import { State } from './State';
import { StateValidator } from './StateValidator';
import { TriggerNode } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Entities/Nodes/TriggerNode';
import { DropzoneNode } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Entities/Nodes/DropzoneNode';
import { EndOfFlowNode } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Entities/Nodes/EndOfFlowNode';
import { uuid } from 'utils';

export interface DefaultFlowStateValidatorModel {
  showSegmentationSplit: boolean;
  onsiteMessageSegments?: {
    segmentId?: string;
    offsiteMessageSegments?: {
      segmentId: string;
    }[];
  }[];
}

/**
 * The canvas is considered to be in the default state if:
 * - branching has not been enabled (showSegmentationSplit is false);
 * - We have not yet added a display website content or send email message:
 *     - onsiteMessageSegments is undefined or empty;
 */
export class DefaultFlowStateValidator implements StateValidator {
  public constructor(private response: DefaultFlowStateValidatorModel) {}

  public validate(): boolean {
    return !this.response.showSegmentationSplit && !this.response.onsiteMessageSegments?.length;
  }
}

/**
 * Produces the default state of the canvas. Three nodes will be created:
 * - Trigger
 * - Dropzone
 * - End of flow
 *
 * By default, only the trigger will be shown.
 */
export class DefaultFlowState implements State {
  public constructor(private validator: StateValidator) {}

  public createCanvas(): Canvas {
    if (!this.validator.validate()) {
      return;
    }

    const canvas = Canvas.createEmptyFlow(c => {
      const triggerRoot = new TriggerNode();

      triggerRoot.setNextNode(new DropzoneNode(), false);
      triggerRoot.setNextNode(new EndOfFlowNode(uuid()), false);
      c.isTriggerInfoShown = false;

      return triggerRoot;
    });

    return canvas;
  }
}
